const configs = require('./config.js').configs;
const defaultData = require('./default_data').data;

export const globalMixin =  {

    data(){
        return {
            /*global AndroidRoutingTest*/
            platform: AndroidRoutingTest ? 'android' : 'desktop',
            // platform:'desktop',
            CurrentBusiness:null,
            Businesses:{ "BusinessList": null, "BusinessCount":0},
            appVersion:null
        }
    },

    methods: {

        fn_getBusiness: function(path){
            let self = this;
            this.getData('AllBusiness', null, {
                onSuccess: function(response){
                    console.log(response);
                    
                    let data  = JSON.parse(response);

                    AndroidRoutingTest.onPageLoadCompleted('1', JSON.stringify({}));

                    if(data){
                        self.CurrentBusiness = data.currentBusiness;
                        self.Businesses.BusinessList = data.businessList;
                        self.Businesses.BusinessCount = data.businessCount;

                        // if(path=='reports'){
                        //     callback ? callback() : self.$router.replace('/'+self.CurrentBusiness.BusinessID+'/reports');
                        // }
                        if(path=='drive' || !self.CurrentBusiness.DataDrive){
                          self.$router.replace({path:'/business/setupdrive'});
                        }
                        else if(path=='restore'){
                          self.$router.replace({path:'/business/restore_data'});
                        }
                        else if(path=='goback'){
                          self.$router.go(-1);
                        }
                        
                    }
                    else{
                        console.log('Unable to load business');
                        self.showToast(self.$t('common.somethingWentWrong'));
                    }
                },
                onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_pushDefaultJson: function(callback){
            var self = this;
            // let dataObj = require('./default_data').data;
            let dataObj = JSON.parse(JSON.stringify(defaultData));
            dataObj.defaultDataJson.transactionSettings[0].businessId = this.CurrentBusiness.BusinessID;
            dataObj.defaultDataJson.godowns[0].stateId = this.$root.CurrentBusiness.StateID;
            this.postData('DefaultData', dataObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        // self.fn_getTransactionSettings();
                        if(self.CurrentBusiness.GSTRegistrationStatus != 1){
                            self.fn_updateTtf(callback);
                        }
                        else{
                            callback();
                        }

                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_updateTtf: function(callback){
            let postObj = {};
            postObj.transactionTypeId = ["10003"];
            postObj.transactionTypeForms = [];
            if(this.CurrentBusiness.GSTRegistrationStatus==1){

                postObj.title = 'Tax Invoice';

                postObj.fieldId = configs.statusUpdate.field.subtitle.id;
                postObj.additionalData = JSON.stringify({"content":null});

                for(let i=0; i<defaultData.defaultDataJson.transactionsType.length; i++){
                    let obj = {};
                    obj.transactionTypeFormId = defaultData.defaultDataJson.transactionsType[i].transactionTypeFormId;
                    obj.taxMode = defaultData.defaultDataJson.transactionsType[i].taxMode;

                    if(defaultData.defaultDataJson.transactionsType[i].transactionTypeFormId == configs.statusUpdate.transactionTypeForm.expense.id){
                        obj.name = "ITC Not Eligible";
                        obj.title = "ITC Not Eligible";
                    }
                    postObj.transactionTypeForms.push(obj);
                }

                this.fn_updateTtfRegister(callback, postObj)
            }
            else if(this.CurrentBusiness.GSTRegistrationStatus==2){
                postObj.title = 'Bill of Supply';
                postObj.taxMode = 0;

                postObj.fieldId = configs.statusUpdate.field.subtitle.id;
                postObj.additionalData = JSON.stringify({"content":"Composition Taxable Person"});

                let obj = {};
                obj.transactionTypeFormId = configs.statusUpdate.transactionTypeForm.expense.id;
                obj.name = "Expense";
                obj.title = "Expense";
                postObj.transactionTypeForms.push(obj);

                this.fn_updateTtfOther(callback, postObj);
            }
            else if(this.CurrentBusiness.GSTRegistrationStatus==3){
                postObj.title = 'Invoice';
                postObj.taxMode = 0;

                postObj.fieldId = configs.statusUpdate.field.subtitle.id;
                postObj.additionalData = JSON.stringify({"content":null});

                let obj = {};
                obj.transactionTypeFormId = configs.statusUpdate.transactionTypeForm.expense.id;
                obj.name = "Expense";
                obj.title = "Expense";
                postObj.transactionTypeForms.push(obj);

                this.fn_updateTtfOther(callback, postObj);
            }
        },

        fn_updateTtfRegister: function(callback, postObj){
            console.log(JSON.stringify(postObj));
            this.postFilterData('UpdateTtfToRegister', null, postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback() : '';
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_updateTtfOther: function(callback, postObj){
            this.postFilterData('UpdateTtfToOther', null, postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback() : '';
                    }, 
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_getAuthToken: function(callback){
            if(!navigator.onLine){
                this.showToast(this.$t('common.internetNotAvailable'));
                this.hideLoading();
                callback('error');
                return;
            }
            
            let self = this;
            this.getData('GetToken', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                        callback('error');
                        self.showToast(self.$t('common.somethingWentWrong'));
                        self.hideLoading();
                    }
                }
            );
        },

        fn_loadMainApp: function(){
            let self = this;
            console.log('load main app called');
            this.getData('LoadMainApp', null, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    }, 
                    onError: function(error){
                        console.log(error);
                        self.showToast(self.$t('common.somethingWentWrong'));
                    }
                }
            );
        },

        fn_postMetrics: function(postObj){
            postObj.eventName = postObj.eventName.replaceAll(" ", "_");
            this.postData("FirebaseAnalyticEvent", postObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_getAndroidAppVer: function(){
            let self = this;
            this.getData('AndroidAppVersion', null, 
            {
                onSuccess: function(response){
                    console.log(response);
                    self.appVersion = Number(response);
                }, 
                onError: function(error){
                    console.log(error);
                }
            });
        },

        fn_logData: function(data){
            console.log(data);
        },

        fn_whatsAppSupport: function(){
            AndroidRoutingTest.openBrowser("https://api.whatsapp.com/send?phone=918882741212");
        },

        // saving to local cache
        fn_saveLocalData: function(dataObj){
            this.postData("LocalData", dataObj, 
                {
                    onSuccess: function(response){
                        console.log(response);
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        // getting from local cache
        fn_getLocalData: function(key, callback){
            this.getData("LocalData", key, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        callback ? callback(response) : '';
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

    },

    mounted: function(){
        //do not remove
        //defining global functions for android communication
        window.js_globals.fn_onBackPress;
        window.js_globals.fn_closeClick;
        window.js_globals.fn_getBottomNavigation;
        window.js_globals.fn_logData = this.fn_logData;
        this.fn_getAndroidAppVer();
    }
}